import React from "react";
import { Link } from "react-router-dom";

import { Check } from "@material-ui/icons";

import { VAT } from "../../constants/actionTypes";

import Prices from "../../utils/prices";

import "./Invoice.css";

const Invoice = ({ uploadQuote, uncountedFiles, payment, small }) => {
  const totals =
    (uploadQuote.files || uploadQuote.languageTo) &&
    Prices(
      uploadQuote.price,
      uploadQuote.totalPages > 0
        ? uploadQuote.totalPages
        : uploadQuote.totalCount,
      uploadQuote.languageTo.length,
      uploadQuote.urgent,
      uploadQuote.addson,
      uploadQuote.totalPages > 0 ? 24 : 0.11
    );

  return (
    <div
      style={{ paddingRight: payment ? "2%" : "", flex: payment ? "0.3" : "" }}
      className={`${
        small ? "invoice__sm" : "invoice"
      } position-sticky d-flex flex-column align-center justify-center t-0 pl-40`}
    >
      <div className="d-flex justify-between font-big font-heavy w-100 py-20 border-bottom-1">
        <span>Your Order</span>
        {!payment && <Link to="/quote">Edit</Link>}
      </div>
      <div className="w-100">
        <div className="d-flex justify-between w-100 py-10">
          {uploadQuote.totalPages ? (
            <>
              <span className="d-flex align-center">
                <Check className="icon-blue mr-10" /> Page count
              </span>
              <span>{`${uploadQuote.totalPages}${
                uploadQuote.totalPages > 1 ? "pages" : "page"
              }`}</span>
            </>
          ) : (
            <>
              <span className="d-flex align-center">
                <Check className="icon-blue mr-10" /> Word count
              </span>
              <span>
                {uncountedFiles > 0
                  ? "NA"
                  : !uploadQuote.totalCount
                  ? "0 word"
                  : `${uploadQuote.totalCount} words`}
              </span>
            </>
          )}
        </div>
        <div className="d-flex justify-between w-100 py-10">
          <span className="d-flex align-center">
            <Check className="icon-blue mr-10" />{" "}
            {uploadQuote.languageFrom ? uploadQuote.languageFrom : "English"} to
          </span>
          <span>
            {uploadQuote.languageTo
              ? `${uploadQuote.languageTo.length} language${
                  uploadQuote.languageTo.length > 1 ? "s" : ""
                }`
              : "1 language"}
          </span>
        </div>
        <div className="d-flex w-100 my-10 ml-20 pl-10">
          {uploadQuote.languageTo ? (
            uploadQuote.languageTo.map((lang) => (
              <span
                key={lang}
                className="invoice__language font-bold px-10 py-5 mr-10 rounded"
              >
                {lang}
              </span>
            ))
          ) : (
            <span className="invoice__language font-bold px-10 py-5 mr-10 rounded">
              Spanish
            </span>
          )}
        </div>
        <div className="d-flex justify-between w-100 py-10">
          <span className="d-flex align-center">
            <Check className="icon-blue mr-10" /> Subject
          </span>
          <span>{uploadQuote.subject ? uploadQuote.subject : "General"}</span>
        </div>
        <div className="d-flex justify-between w-100 py-10">
          <span className="d-flex align-center">
            <Check className="icon-blue mr-10" /> Package
          </span>
          <span>{uploadQuote.category ? uploadQuote.category : "Advance"}</span>
        </div>
        <div className="d-flex justify-between w-100 py-10">
          <span className="d-flex align-center">
            <Check className="icon-blue mr-10" /> Delivery date
          </span>
          <span>
            {uploadQuote.urgent ? "In 48 hours" : "In 5 working days"}
          </span>
        </div>
        <div className="d-flex justify-between w-100 py-10">
          <span className="d-flex align-center">
            <Check className="icon-blue mr-10" /> Price per{" "}
            {uploadQuote.totalPages ? "page" : "word"}
          </span>
          <span>
            {uploadQuote.price
              ? `$${uploadQuote.price}/${
                  uploadQuote.totalPages ? "page" : "word"
                }`
              : "$4.99/word"}
          </span>
        </div>
        {uploadQuote?.addson?.certified !== 0 && (
          <div className="d-flex justify-between w-100 py-10">
            <span className="d-flex align-center">
              <Check className="icon-blue mr-10" /> Certified
            </span>
            <span>
              ${Math.ceil(uploadQuote?.addson?.certified * 100) / 100}
            </span>
          </div>
        )}
        {uploadQuote?.addson?.sworn !== 0 && (
          <div className="d-flex justify-between w-100 py-10">
            <span className="d-flex align-center">
              <Check className="icon-blue mr-10" /> Sworn Certification
            </span>
            <span>${Math.ceil(uploadQuote?.addson?.sworn * 100) / 100}</span>
          </div>
        )}
        {uploadQuote?.addson?.notarization !== 0 && (
          <div className="d-flex justify-between w-100 py-10">
            <span className="d-flex align-center">
              <Check className="icon-blue mr-10" /> Notarization
            </span>
            <span>
              ${Math.ceil(uploadQuote?.addson?.notarization * 100) / 100}
            </span>
          </div>
        )}
        {uploadQuote?.addson?.apostilles !== 0 && (
          <div className="d-flex justify-between w-100 py-10">
            <span className="d-flex align-center">
              <Check className="icon-blue mr-10" /> Apostilles
            </span>
            <span>
              ${Math.ceil(uploadQuote?.addson?.apostilles * 100) / 100}
            </span>
          </div>
        )}
        <div className="d-flex justify-between w-100 py-10">
          <span className="d-flex align-center">
            <Check className="icon-blue mr-10" /> VAT ({`${VAT}%`})
          </span>
          <span>
            ${Math.ceil((isNaN(totals?.vat) ? 0 : totals?.vat) * 100) / 100}
          </span>
        </div>
        <div className="d-flex justify-between py-10">
          <span className="d-flex align-center">
            <Check className="icon-blue mr-10" /> Subtotal
          </span>
          <span>
            {uncountedFiles > 0
              ? "NA"
              : !uploadQuote.totalCount
              ? "$0.00"
              : `$${Math.ceil(totals?.subtotal * 100) / 100}`}
          </span>
        </div>
        <div className="d-flex justify-between px-10 py-10 my-10 font-bold border-top-1 border-bottom-1 font-big">
          <span>Total</span>
          <span>
            {uncountedFiles > 0
              ? "NA"
              : !(uploadQuote.totalCount * 1)
              ? "$0.00"
              : `$${Math.ceil(totals?.total * 100) / 100}`}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Invoice;
